export const GET_LIST_FACE_PENDING_USERS = "GET_LIST_FACE_PENDING_USERS"
export const GET_LIST_FACE_PENDING_USERS_ERR = "GET_LIST_FACE_PENDING_USERS_ERR"

export const VERIFY_AVATAR = "VERIFY_AVATAR"
